<template>
  <vs-popup title="Justificativas" :active="show" @update:active="$emit('update:show')">
    <div class="_suggestion-guest-justifications">
      <div class="pb-2" v-html-safe="getIntroText()"></div>
      <b-alert v-for="item, key in items" :key="key"
        show
        variant="warning"
      >
        <div class="__item-alert h-full w-full flex flex-col" v-if="item.suggestion_id">
          <span>De <i>{{formatDate(item.suggestion_start_at)}}</i> até <i>{{formatDate(item.suggestion_finish_at)}}</i></span>
          <p>{{item.text}}</p>
        </div>
        <div class="__item-alert h-full w-full flex flex-col" v-else>
          <span>Não poderá participar do evento</span>
          <p>{{item.text}}</p>
        </div>
      </b-alert>
    </div>
  </vs-popup>
</template>

<script>

import {
  BTable,
  BAlert,
} from 'bootstrap-vue'

export default {
  components: {
    BTable,
    BAlert,
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    show: {
      type: Boolean,
      default: false
    },
    guest: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    fields: [
      {key: 'text', label: "Justificativa"},
      {key: 'suggestion_start_at', label: "Data Início"},
      {key: 'suggestion_finish_at', label: "Data Fim"}
    ]
  }),
  computed: {
    guestName() {
      return (this.guest && this.guest.name) || (this.guest && this.guest.entity && this.guest.entity.name) || null
    },
    hasAnyEventJustification() {
      if (this._.isArray(this.items) && this.items.length > 0) {
        this._.some(this.items, 'schedule_event_id')
      } else return false
    },
  },
  methods: {
    formatDate(timestamp) {
      const format = 'ddd DD/MM/YYYY HH:mm'
      return this.$utils.format.dateWithFormat(timestamp, format)
    },
    getIntroText() {
      const guestName = this.guestName
      const leading = (
        this.hasAnyEventJustification ?
        `O(A) convidado(a) <i>${guestName}</i> justificou que não irá participar do evento.` :
        `O(A) convidado(a) <i>${guestName}</i> justificou que não poderá participar de alguma data/horário sugerida.`
      )
      const mid = (
        (this.hasAnyEventJustification && this.items.length >= 3) ?
        `E também não poderia participar de alguns horários.` :
        ``
      )
      const conclusion = (
        this.items.length > 1 ?
        '<br/>Veja abaixo as justificativas.' :
        '<br/>Veja abaixo a justificativa.'
      )

      return `${leading} ${mid} ${conclusion}`
    },
  }
}
</script>

<style lang="scss">

._suggestion-guest-justifications {
  & .__item-alert {
    @apply rounded;
    & span {
      @apply font-semibold;
      color: white;
      background-color: #ea8454;
      display: block;
      border: 1px solid rgb(175, 73, 14);
      border-left-width: 0;
      border-right-width: 0;
      border-top-width: 0;
      width: 100%;
    }
    & > * {
      @apply p-1;
    }

    & > :nth-child(1) {
      @apply rounded rounded-b-none;
    }

    & > :nth-child(2) {
      @apply rounded rounded-t-none;
    }
  }
}

</style>